import React, { useEffect, useState } from 'react';
import UserSidebar from './UserSidebar';
import UserTopbar from './UserTopbar';

const STORE_KEY = 'ql.sidebar.collapsed';

/** Sidebar + topbar around a user-dashboard page. */
const UserShell = ({ activeTab, onTabChange, search, onSearch, suggestions, onPickSuggestion, children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(STORE_KEY) === '1'; } catch { return false; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(STORE_KEY, collapsed ? '1' : '0'); } catch { /* private window */ }
  }, [collapsed]);

  // The drawer must not stay open behind a resize back to desktop.
  useEffect(() => {
    const onResize = () => { if (window.innerWidth >= 1024) setMobileOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div className="flex min-h-screen bg-[#f4f7fc] dark:bg-[#080d19]">
      <UserSidebar
        activeTab={activeTab}
        onTabChange={onTabChange}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((v) => !v)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <div className="flex-1 min-w-0 flex flex-col">
        <UserTopbar
          search={search}
          onSearch={onSearch}
          suggestions={suggestions}
          onPickSuggestion={onPickSuggestion}
          onOpenMenu={() => setMobileOpen(true)}
        />
        <main className="flex-1 min-w-0 px-4 sm:px-6 py-5 sm:py-6">{children}</main>
      </div>
    </div>
  );
};

export default UserShell;
